import React from "react";
const Unauthorized = () => {
    return <h1>Unauthorized - You do not have access to this page</h1>;
  };
  
  export default Unauthorized;